import { FieldSkeleton } from '@/components/layout/field-row'

import * as S from './block-item.styled'

export const SkeletonBlockItem = () => (
  <S.Row>
    <FieldSkeleton height="1.6rem" variant="rectangular" width="100%" />
  </S.Row>
)
